module.exports = __webpack_public_path__ + "img/muvelet2.aa4767ba.png";